// extracted by mini-css-extract-plugin
module.exports = {"cjd3ep5":"cjd3ep5"};